import { ClassificationParameterExtended } from "../interfaces/classification";

export const isLabelParameter = (parameter: ClassificationParameterExtended): boolean => {
  return ["fontColor", "haloColor", "textBackground.fill.color"].includes(parameter);
};
